(function() { window.GUID_d2eee958_5d8a_4d18_b666_72a6cf7c314c = { getGuid: function() { return "d2eee958-5d8a-4d18-b666-72a6cf7c314c"; } }; })();
var CS;
(function (CS) {
    class GlobalConst {
        constructor(jsonData) {
            let data = JSON.parse(jsonData);
            GlobalConst.FacebookAppKey = data.FacebookAppKey;
            GlobalConst.FacebookGraphApiVersion = data.FacebookGraphApiVersion;
            GlobalConst.PictureSizes = data.PictureSizes;
            GlobalConst.ForceFullNavigation = data.ForceFullNavigation;
            GlobalConst.EnableSignalR = data.EnableSignalR;
            GlobalConst.EnableGoogleAnalytics = data.EnableGoogleAnalytics;
            GlobalConst.UseInfolinksAds = data.UseInfolinksAds;
            GlobalConst.UseGoogleAdsense = data.UseGoogleAdsense;
            GlobalConst.UseEzoicAds = data.UseEzoicAds;
        }
    }
    CS.GlobalConst = GlobalConst;
})(CS || (CS = {}));

//# sourceMappingURL=cs-globalconst.js.map
